import { Subject } from "rxjs";

const loginObservable = new Subject()

export { loginObservable }